export default {
   currentCategory: {},
    shopCart: {},
    /*
    * 用户信息
    * */
    userInfo: {}
}